module.exports = __webpack_public_path__ + "static/media/video_games.fdac9af0.gif";